import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { SET_CHARACTER_HISTORY, SHOW_CHARACTER_HISTORY_LOADING_SPINNER } from '../actions/characterHistoryActions';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TCharacterDetailsClientState } from '../libs/store';

export default function characterHistory(
  state: Partial<TCharacterDetailsClientState> = {},
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  switch (action.type) {
    case SET_CHARACTER_HISTORY: {
      return {
        ...state,
        ...action.payload
      };
    }
    case SHOW_CHARACTER_HISTORY_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }

      return {};
    }
    default: {
      return state;
    }
  }
}
